export enum ProjectStatus {
    Archived = 'archived',
    InProgress = 'in_progress',
    Complete = 'complete',
}
